import tw from "twin.macro";
import NavItems from "./NavItems";
import { RiMenu2Line, RiCloseLine } from "react-icons/ri";
import { useState } from "react";
import { Link } from "gatsby";
import { NavItemsData } from "../../data/NavItemsData";
import { Bounce } from "react-reveal";
import React from "react";
import Fade from "react-reveal/Fade";

const Navbar = ({ isHashLink }) => {
  const [menu, setMenu] = useState(false);
  const onClick = () => setMenu(!menu);

  const [changenavbar, setchangenavbar] = useState(false);

  function changebackground() {
    if (typeof window !== "undefined") {
      if (window.scrollY >= 10) setchangenavbar(true);
      else setchangenavbar(false);
    }
  }
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", changebackground);
  }
  // const changeWhiteText = [changenavbar ? tw`text-black` : tw`text-white`];

  return (
    <nav
      css={[
        changenavbar
          ? tw`shadow-md bg-gray-700 `
          : tw`bg-gray-700 md:(bg-transparent) `,
      ]}
      tw=" fixed z-10 w-full left-0 top-0 p-4   space-y-1  text-center items-center"
    >
      <div tw="md:(flex space-y-0 justify-between)">
        <div tw="flex justify-between ">
          <Bounce>
            <Link
              to="/"
              tw=" text-3xl tracking-wider font-light  no-underline text-white"
            >
              Tech Tomatoes
            </Link>
          </Bounce>

          <div tw="flex  items-center justify-center px-4 ">
            <div tw="md:hidden"></div>
            {!menu ? (
              <RiMenu2Line
                onClick={onClick}
                tw=" text-3xl md:hidden mr-2 cursor-pointer text-white"
              />
            ) : (
              <RiCloseLine
                onClick={onClick}
                tw=" text-3xl md:hidden mr-2 cursor-pointer text-white"
              />
            )}
          </div>
        </div>

        <Fade top cascade>
          <div
            css={[menu ? tw`right-0 ` : tw`-right-full`]}
            tw="fixed z-50 transition-all   px-4 items-center w-screen h-screen bg-gray-700 md:(bg-transparent)  space-y-10 md:(static flex h-auto space-y-0 w-auto)"
          >
            {NavItemsData.map((item, index) => (
              <div key={index} tw="(space-y-10 mt-10) md:(space-y-0 mt-0) ">
                <NavItems
                  isHashLink={isHashLink}
                  onClick={onClick}
                  to={item.link}
                  toHash={item.HashLink}
                  isLink={item.islink}
                >
                  <div tw="flex items-center space-x-2 font-bold text-white">
                    <item.icon />
                    <p tw="font-medium">{item.name}</p>
                  </div>
                </NavItems>
              </div>
            ))}
          </div>
        </Fade>
      </div>
    </nav>
  );
};

export default Navbar;
